export default __webpack_public_path__ + "static/media/Comp 2_00046.5a45c241.png";